import Service from "../../AuthService";

const deposit = {
    getDeposit(page) {
        return Service.get("/deposit?page="+page);
    },
    showDeposit(id,page) {
        return Service.get("/deposit/" + id +'?page='+page);
    },
    updateDeposit(id, data) {
        return Service.put("/deposit/" + id, data);
    },
    createDeposit(data) {
        return Service.post("/deposit", data);
    },
    deleteDeposit(id) {
        return Service.delete("/deposit/" + id);
    },
    search(page,data){
        return Service.post('/deposit-search?page='+page,data);
    }

};
export default deposit;
